import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFaq = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", { d: "M6,1.5v3H0v-3A1.49,1.49,0,0,1,1.46,0h3A1.5,1.5,0,0,1,6,1.5ZM0,6H6V18H0ZM0,19.5H6l-.08,3a1.47,1.47,0,0,1-1.46,1.46h-3A1.46,1.46,0,0,1,0,22.46Zm7.46-.08h6v3A1.45,1.45,0,0,1,12,23.92H9a1.47,1.47,0,0,1-1.5-1.46ZM19.29,4,13.5,5.55l-.28-1H7.5l0-3A1.49,1.49,0,0,1,9,0h3a1.49,1.49,0,0,1,1.4,1,1.13,1.13,0,0,1,.38-.19l2.9-.78a1.51,1.51,0,0,1,1.84,1.06ZM7.5,6h6V18h-6ZM22.79,17,17,18.56,13.89,7l5.79-1.55Zm.1,6.16L20,24a1.5,1.5,0,0,1-1.83-1.06L17.38,20l5.8-1.55L24,21.34A1.49,1.49,0,0,1,22.89,23.17Z" })]
});
const ForwardRef = forwardRef(SvgFaq);
export default ForwardRef;
